/**
 * Loans — every amortising debt in YNAB, projected the way a New Zealand lender does it.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchLoans, queryKeys } from '../api.ts'
import { LoanPanel } from '../components/LoanPanel.tsx'
import { fmt } from '../lib/format.ts'

export function Loans() {
  const loans = useQuery({ queryKey: queryKeys.loans, queryFn: fetchLoans })
  const total = (loans.data ?? []).reduce((sum, loan) => sum + loan.balance, 0)

  return (
    <section className="flex flex-col gap-5 px-4 pt-[22px] pb-[60px] sm:px-7">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="flex flex-col gap-1.5">
          <h2 className="m-0 font-display text-[34px] font-normal leading-none">Loans</h2>
          <p className="m-0 max-w-[600px] text-[14px] text-muted">
            The balance is YNAB's. The terms are yours: interest accrues daily, the rate is fixed
            for a term and then reprices, and the bank holds the maturity date — none of which
            YNAB's loan planner knows.
          </p>
        </div>
        {loans.data && loans.data.length > 1 && (
          <div className="flex flex-col sm:items-end">
            <span className="text-[10px] uppercase tracking-[0.14em] text-muted">Owing in all</span>
            <span className="font-display text-[26px] leading-none">{fmt(total)}</span>
          </div>
        )}
      </div>

      {loans.isPending && <p className="text-[14px] text-muted">Loading the loans…</p>}
      {loans.isError && (
        <p className="rounded-card bg-blush-soft p-4 text-[14px] text-blush-deep">
          {loans.error.message}
        </p>
      )}
      {loans.data?.length === 0 && (
        <p className="text-[14px] text-muted">
          No open loan accounts in YNAB. A mortgage, car or personal loan shows up here once it is
          added there.
        </p>
      )}
      {loans.data?.map((loan) => (
        <LoanPanel key={loan.accountId} loan={loan} />
      ))}
    </section>
  )
}
